import React from "react";

function Hero() {
  return (
    <section className="banner_style_five">
      {/* Background Layer */}
      <div
        className="bg_layer"
        style={{
          backgroundImage: "url(/images/resource/hero-img.png)",
        }}
      ></div>

      <div className="container">
        <div
          className="banner_content text-center"
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="500"
        >
          {/* <h1>Empowering Finance with Innovation</h1>
          <p>
            At Brain Fintech, we are transforming businesses with smart
            financial solutions that drive growth, security and efficiency.
          </p> */}

          {/* Button Area */}
          {/* <div className="banner_btn_area mt-4">
            <div className="link_btn">
              <a href="/contact" className="btn_style_one">
                Get Started
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Hero;
